<template>
	<div class="px-4 sm:px-0">
		<div class="flex justify-between">
			<div class="flex py-2 my-2 text-sm" v-if="isSuperAdmin">
				<div class="ml-1 flex items-center" v-for="(regionName, regionId) in regions" @click="toggleFilter(regionId)">
					<div class="w-3 h-3 rounded-full border border-transparent ml-1" :class="filter.indexOf(Number(regionId)) == -1 ? 'bg-red-500 font-linethrough' : 'bg-green-400'"></div>
					<span class="ml-1">{{ regionName }}</span>
				</div>
			</div>
		</div>
		<div class="flex p-2 my-2">
			<router-link to="/jobs/new" v-if="isSuperAdmin">
				<action-button class="btn btn-blue flex items-center">
					<plus-icon class="w-5 h-5 mr-1"></plus-icon>
					<span>Job</span>
				</action-button>
			</router-link>
		</div>
		<fetch-json url="jobs" method="get" :params="{userid:userid,role:currentRole,region:region}" :key="currentKey">
			<div class="" slot-scope="{ data: jobs, loading }">
				<div v-if="loading" class="text-grey-darker">
					Loading...
				</div>
				<div v-else-if="!jobs.length" class="text-grey-darker">
					No jobs <router-link class="link" to="/jobs/new" v-if="isAdmin">,add one</router-link>!
				</div>
				<div v-else>
					<div class="flex justify-between items-center p-2 sm:p-4 bg-gray-200 mb-4" v-for="job in jobs" :key="job.id" >
						<router-link class="flex-1 flex items-center" :to="whichUrl(job.id)">
							<div class="w-3 h-3 rounded-full border mr-4" :class="`${job.status}Class`" v-if="isAdmin"></div>
							<h2 class="text-xl font-normal sm:text-3xl">{{ job.name }}</h2>
						</router-link>
						<!-- <div v-else class="flex items-center">
							<h2 class="text-xl font-normal sm:text-3xl">{{ job.name }}</h2>
						</div> -->
						<div class="flex justify-end items-center space-x-2 text-blue-400">
							<router-link class="flex flex-col items-center text-xs w-14 whitespace-nowrap flex-shrink-0" :to="whichUrl(job.id)" v-if="! isAdmin && canOrder">
								<plus-icon class="w-5 h-5 mb-1"></plus-icon>
								New Order
							</router-link>
							<router-link class="flex flex-col items-center text-xs w-14 whitespace-nowrap flex-shrink-0" :to="`/jobs/${job.id}/templates`" v-if="currentRole == 'Head Office Storeman' || isSuperAdmin">
								<box-icon class="w-5 h-5 mb-1"></box-icon>
								Templates
							</router-link>
							<div class="relative" v-if="canViewForecast">
								<action-button class="flex flex-col items-center text-xs w-14 whitespace-nowrap flex-shrink-0" @button-clicked="toggle('forecasts', job.id)">
									<activity-icon  class="w-5 h-5 mb-1 red-800"></activity-icon>
									<span>Forecasts</span>
								</action-button>
								<button class="fixed inset-0 w-full h-full cursor-default" v-if="menus.forecasts[job.id]" @click="toggle('forecasts', job.id)"></button>
								<div class="absolute lg:right-0 mt-2 py-2 bg-white rounded-lg shadow-lg z-10 w-48" v-if="menus['forecasts'][job.id]">
									<router-link class="block py-2 px-4 hover:bg-gray-300" :to="`/job/${job.id}/orderforecast`" v-if="canCreateForecast" v-on:click="CleanForecast"> <!--  v-if="job.forecast_order!='done' && show_forecast" -->
										New Forecast
									</router-link>
									<router-link class="block py-2 px-4 hover:bg-gray-300" :to="`/job/${job.id}/forecasts`">
										View Forecasts
									</router-link>
								</div>
							</div>
							<router-link class="flex flex-col items-center text-xs w-14 whitespace-nowrap flex-shrink-0" :to="currentRole != 'Head Office Storeman' ? `/job/${job.id}/orders` : `/job/${job.id}/orders/new`">
								<clipboard-icon class="w-5 h-5 mb-1"></clipboard-icon>
								Orders
							</router-link>
							<div class="relative" v-if="isSuperAdmin">
								<button class="flex flex-col items-center text-xs w-14 whitespace-nowrap flex-shrink-0" @click="toggle('edit', job.id)">
									<edit-icon class="w-5 h-5 mb-1"></edit-icon>
									<span>Edit job</span>
								</button>
								<button class="fixed inset-0 w-full h-full cursor-default" v-if="menus.edit[job.id]" @click="toggle('edit', job.id)"></button>
								<div class="absolute lg:right-0 mt-2 py-2 bg-white rounded-lg shadow-lg z-10 w-48" v-if="menus['edit'][job.id]">
									<router-link class="block py-2 px-4 hover:bg-gray-300" :to="`/job/${job.id}`" title="View details">
										Job Details
									</router-link>
									<router-link class="block py-2 px-4 hover:bg-gray-300" :to="`/job/${job.id}/edit`" title="Edit">
										Job Info
									</router-link>
								</div>
							</div>
							<button class="flex flex-col items-center text-xs w-14 whitespace-nowrap flex-shrink-0 link link-red" @click="confirmDelete(job.id)" v-if="isAdmin">
								<trash-2-icon class=" rounded w-5 h-5 mb-1 cursor-pointer hover:bg-white"></trash-2-icon>
								Delete
							</button>
						</div>
					</div>
				</div>
			</div>
		</fetch-json>
		<portal to="modals" v-if="showDelete" :order="2">
			<confirm-delete
				:show="showDelete"
				:delete-object="showDelete"
				@close="showDelete = null"
				@delete="deleteObject"
			>
			</confirm-delete>
		</portal>
		<portal to="modals" v-if="ordersNeedingApproval && Object.keys(ordersNeedingApproval).length" :order="3">
			<orders-modal
				:show="Object.keys(ordersNeedingApproval).length"
				:initial-jobs="ordersNeedingApproval"
			>
			</orders-modal>
		</portal>
	</div>
</template>

<script>
import { Trash2Icon } from 'vue-feather-icons'
import { BoxIcon } from 'vue-feather-icons'
export default {
	name: 'home',
	data () {
		return {
			currentKey: 1,
			role: null,
			region: null,
			userid: null,
			showDelete: null,
			menus: {
				forecasts: {},
				edit: {},
			},
			regions: {
				1: 'Gauteng',
				2: 'KZN',
				3: 'Cape Town',
			},
			filter: [
				1,
				2,
				3,
			],
			filtered: false,
		}
	},
	computed: {
		isSuperAdmin: function(){
			return this.role === 'Super Admin';
		},
		isAdmin: function(){
			return this.role === 'Administrator';
		},
		canOrder: function(){
			return this.isAdmin || this.isSuperAdmin || this.role === 'Regional Manager' || this.role === 'Reticulation manager' || this.role === 'Foreman' || this.role === 'Site Manager';
		},
		canViewForecast: function(){
			return this.isAdmin || this.isSuperAdmin || this.role === 'Regional Manager' || this.role === 'Reticulation manager' || this.role === 'Site Manager';
		},
		canCreateForecast: function(){
			return this.isAdmin || this.isSuperAdmin || this.role === 'Regional Manager' || this.role === 'Reticulation manager';
		},
		currentRole: function(){
			return this.$store.getters['auth/role'];
		},
		ordersNeedingApproval: function(){
			return this.$store.getters['auth/ordersNeedingApproval'];
		},
	},
	watch: {
		currentRole: function(val){
			this.role = val;
			this.currentKey++;
		},
	},
	methods: {
		toggleFilter(regionId) {
			regionId = Number(regionId);
			let indexOfRegion = this.filter.indexOf(regionId);
			if(indexOfRegion == -1){
				this.filter.push(regionId);
			}else{
				this.filter.splice(indexOfRegion, 1);				
			}
			this.region = this.filter;
			this.currentKey ++;
		},
		CleanForecast()
		{
			this.$store.commit('forecast/emptyStore');
		},
		confirmDelete: function (id) {
			this.showDelete = {
				name: 'job',
				id: id
			}
		},
		deleteObject: function (obj) {
			this.$http.delete(`jobs/${obj.id}`)
				.then(response => {
					this.showDelete = null
					this.currentKey ++;
				})
				.catch(error => {
					console.log(error)
					let err = {
						title: 'Server responded with a ' + error.response.status,
						message: error.response.data.message,
						type: 'error'
					}
					this.$store.commit('setStatus', err)
				})
		},
		toggle: function(what, id){
			if(this.menus[what][id]){
				this.menus[what][id] = !this.menus[what][id];
				return;
			}else{
				this.$set(this.menus[what], id, true);
			}
		},
		whichUrl: function(jobId){
			if(this.canOrder){
				return `/job/${jobId}/order`;
			}
			if(this.role == 'Head Office Storeman'){
				return `/job/${jobId}/orders/new`;
			}
			return `/job/${jobId}/orders`;
		}
	},
	components: {
		Trash2Icon,
		BoxIcon
	},
	created () {
		this.role = this.$store.getters['auth/role']
		this.region = this.isAdmin ? this.filter : this.$store.getters['auth/region_id']
		this.userid = this.$store.getters['auth/userid']
		this.$store.commit('setJobName', null);
	}
}
</script>
<style lang="css" scoped>
	.pendingClass {
		@apply border-transparent bg-red-400;
	}
	.activeClass {
		@apply border-transparent bg-green-500;
	}
	.archivedClass {
		@apply border-transparent bg-gray-300;
	}
</style>
